import { camelize } from 'humps';
import INPUT_TYPES, { INTERNAL_IDS } from './constants';
import { getCompatibleDateFormat, baseMoment } from './dates';

const { DATE_TIME } = INPUT_TYPES;
const TIME_INTERNAL_IDS = [INTERNAL_IDS.arrivalTime, INTERNAL_IDS.departureTime];
export default (fields, customFields) => {
  const parsedFields = {};
  Object.keys(fields).forEach((field) => {
    if (customFields[field]) parsedFields[camelize(customFields[field].name)] = fields[field];
  });
  return parsedFields;
};

const defaultAnswers = {
  // TODO: Update to wm-2026 IDs
  // 1951: 'No', // accompanying
  // 1955: 'No', // joining
  // 1952: 'No', // same room
};

export const defaultAttendeeFieldsValues = (fields, customFields) => {
  const attendee = { customFields: {} };
  Object.keys(fields).forEach((field) => {
    // Comes null by default, needs to be set to "No" so the
    // "No" option shows checked in the radio button
    if (
      defaultAnswers[customFields[field].internalId]
    ) attendee.customFields[`_${field}`] = fields[field] || defaultAnswers[customFields[field].internalId];

    else if (customFields[field]?.default) attendee[customFields[field].name] = fields[field];
    else if (!!customFields[field]
      && !customFields[field].default) if (customFields[field]
      .inputType === DATE_TIME) {
      const { includeTime } = customFields[field];
      const value = getCompatibleDateFormat(fields[field], includeTime);
      attendee.customFields[`_${field}`] = value;
    } else if (
      TIME_INTERNAL_IDS.includes(customFields[field].internalId)
      && fields[field]
    ) {
      attendee.customFields[`_${field}`] = baseMoment(
        fields[field],
        ['h:mm A', 'h:mm:ss A', 'HH:mm', 'HH:mm:ss']
      ).format('HH:mm');
    } else attendee.customFields[`_${field}`] = fields[field];
  });
  return { attendee };
};

export const parseFieldsByInternalId = (fields = {}, customFields) => {
  const result = {};
  Object.keys(fields).forEach((field) => {
    if (customFields[field]) result[(customFields[field].internalId)] = customFields[field].id;
  });
  return result;
};
